/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "react-flexbox-layout/lib/styles.css";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import LaunchpadContainer from "src/pods/launchpad/components/LaunchpadContainer";
import HostStateContainer from "src/pods/realtime/components/HostStateContainer";

export default function LaunchpadPage() {
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.toolkit", "dojo.common"]);
  const params = useParams();
  return <HostStateContainer>{ready ? <LaunchpadContainer params={params} /> : <noscript />}</HostStateContainer>;
}
